import { SystemModulesEnum } from '@models/module/main/systemModules.enum';

export const HYBRID_MODULE_ROUTE_PARTS = {
  [SystemModulesEnum.Contracts]: 'Contracts',
  [SystemModulesEnum.ChangeOrder]: 'ChangeOrder',
  [SystemModulesEnum.Projects]: 'Projects',
  [SystemModulesEnum.Programs]: 'Programs',
  [SystemModulesEnum.SOV]: 'SOV',
  [SystemModulesEnum.ProgressPayment]: 'ProgressPayment',
} as const;
